import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/shared/link';
import Heading from 'components/shared/heading';

import classNames from 'classnames/bind';
import styles from './cards-with-reviews.module.scss';

const cx = classNames.bind(styles);

const CardsWithReviews = ({ title, items = [] }) => {
  return (
    <section className={cx('wrapper')}>
      <div className="container">
        <Heading className={cx('title')} tag="h2" size="xl">
          {title}
        </Heading>

        <div className={cx('items', `items-columns-${items.length}`)}>
          {items.map(({ title, caption, text, link }, index) =>
            link ? (
              <Link className={cx('item', 'item-with-link')} to={link} key={index}>
                <div>
                  <Heading className={cx('item-title')} tag="h3" size="md">
                    {title}
                  </Heading>
                  <span className={cx('item-caption')}>{caption}</span>
                  <p className={cx('item-text')}>{text}</p>
                </div>
                <div className={cx('item-footer')}>
                  <span className={cx('item-read-more')}>Read more</span>
                </div>
              </Link>
            ) : (
              <div className={cx('item')} key={index}>
                <div>
                  <Heading className={cx('item-title')} tag="h3" size="md">
                    {title}
                  </Heading>
                  <span className={cx('item-caption')}>{caption}</span>
                  <p className={cx('item-text')}>{text}</p>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
};

CardsWithReviews.propTypes = {
  title: PropTypes.string.isRequired,

  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      caption: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default CardsWithReviews;
